import { oz } from '@weft/utils';
import { MetersForProductPageResponseSchema } from './meters-for-products-page-schema';
import { MeterWithTotalMeasurementsResultSchema } from './meters-with-total-measurements';
import { TotalRevenueSchema } from './total-revenue-schema';

export const ProductsPageSchema = oz.object({
  totalRevenue: TotalRevenueSchema,
  meters: MetersForProductPageResponseSchema,
  metersWithMeasurements: oz.array(MeterWithTotalMeasurementsResultSchema),
  countedTotalMeters: oz.number().nonnegative(),
  countedFilteredMeters: oz.number().nonnegative(),
}).openapi('ProductsPageData');
  
export type ProductsPageData = oz.infer<typeof ProductsPageSchema>;